/**
 * Created by Thomas Mark
 * Date: 2020-05-01
 * 
 * Freigestelltes Produktbild anzeigen
 *
 */
import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as portfolioActions from '../../../store/actions/portfolioActions';
import * as fileActions from "../../../store/actions/fileActions";
import * as appActions from "../../../store/actions/appActions";
import * as utils from "../../../basics/utils";
import ProductDetails from "./ProductDetails";
import { FabIconDelete } from "../../partials/Icons";
import UploadArea from "../../partials/UploadArea";
import { ImageLoader } from "../../partials/ImageLoader";


class ProductFree extends React.Component {
    constructor(props) {
        super(props);

        this.debug = false;
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { unitHeight, path, orientation, appModus } = this.props.app;
        const { currentProduct } = this.props.portfolio;

        const dialog = utils.getDialogByPath(path);

        if (currentProduct === null) return null;

        // ==========================================================================
        // 
        // SUB RENDER
        // 
        // ==========================================================================

        const renderFreeImage = () => {

            const styleOuter = {
                height: '60%',
                backgroundColor: (this.debug) ? 'blue' : '',
            };

            if (appModus === 'Admin') {
                if (!this.props.node) return null;

                const nodeImage = utils.getProductImage(this.props.node, path, 'free');

                const styleInner = utils.getStyleBackgroundURL(nodeImage.url);

                const onDelete = () => {
                    const onDeleteSuccess = (data) => {
                        this.props.scanPortfolio(dialog.portfolio);
                    }

                    const onDeleteError = (error) => {
                        console.log('onDelete() error:', error);
                    }

                    this.props.deleteFile('product', path, nodeImage.fileName, onDeleteSuccess, onDeleteError);
                }

                if (nodeImage.fileName === '') {
                    return (<UploadArea uploadArea='image' uploadType='product' uploadPath={path} uploadPost='free' />)
                } else {
                    return (
                        <div className="relative w-full" style={styleOuter}>
                            <div className="absolute w-full" style={styleInner}></div>
                            {FabIconDelete("Bild entfernen", onDelete)}
                        </div>
                    )
                }

            } else {
                if (!this.props.node) return null;

                const fileObj = utils.getFileInNode(this.props.node, 'free');
                if (!fileObj) return null;

                return (
                    <div className="w-full p-2" style={styleOuter}>
                        <ImageLoader path={fileObj.path} name={fileObj.name} height={'100%'} cover={'cover'} />
                    </div>
                )
            }
        }

        const renderProperties = () => {

            const style = {
                height: '40%',
                backgroundColor: (this.debug) ? 'blue' : '',
            };

            return (
                <div className="w-full" style={style}>
                    <ProductDetails node={currentProduct} height={unitHeight * ((orientation === 'landscape') ? .6 : .5)} version='large' />
                </div>
            )
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================
        return (
            <div className="w-full h-full flex flex-col">
                {renderFreeImage()}
                {renderProperties()}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        user: state.user,
        file: state.file,
        portfolio: state.portfolio,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, fileActions, portfolioActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductFree);
